import { ChangeEvent, ReactElement } from "react";
import { FormField, TextInput } from "@justworkshr/milo-form";

const EditProfileEmailInput = ({
  email,
  label,
  inlineError,
  disabled,
  onChange,
}: {
  email: string;
  label: string;
  inlineError?: string;
  disabled: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}): ReactElement => {
  return (
    <FormField label={label} required={true} error={inlineError}>
      <TextInput
        name="email"
        value={email}
        disabled={disabled}
        onChange={onChange}
      />
    </FormField>
  );
};

export default EditProfileEmailInput;
